export default __webpack_public_path__ + "static/media/rewardImg.2fc6360e.png";